import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  fetchFeatureFlag,
  selectFeatureFlag,
  selectFeatureFlagsLoading,
} from "../features/featureFlags/featureFlagsSlice";

export const useFeatureFlag = (
  flagName,
  defaultValue = false,
  autoFetch = true,
) => {
  const dispatch = useDispatch();
  const flagValue = useSelector(selectFeatureFlag(flagName));
  const loading = useSelector(selectFeatureFlagsLoading);

  const refetch = () => {
    dispatch(fetchFeatureFlag({ flagName, defaultValue }));
  };

  useEffect(() => {
    if (autoFetch && flagValue === undefined) {
      dispatch(fetchFeatureFlag({ flagName, defaultValue }));
    }
  }, [flagName, autoFetch, flagValue, defaultValue, dispatch]);

  return {
    value: flagValue !== undefined ? flagValue : defaultValue,
    loading,
    refetch,
  };
};

export const usePreloadFlags = (flagNames) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectFeatureFlagsLoading);

  useEffect(() => {
    if (flagNames && flagNames.length > 0) {
      flagNames.forEach((flagName) => {
        dispatch(fetchFeatureFlag({ flagName, defaultValue: false }));
      });
    }
  }, [flagNames, dispatch]);

  return { loading };
};
